import { formatDateStandard } from '@/services/dateFormatter';
import dayjs from 'dayjs';

export default interface ArretAATState {
	arret?: ArretAAT;
}

export class ArretAAT {
	isEnRapportAvecATMP: boolean;
	dateDebutATMP: string;
	dateDebut: string;
	dateFin: string;
	isRepriseTempsLeger: boolean;
	dateDebutRepriseTL: string;
	dateFinRepriseTL: string;
	dureeTL: string;
	duree: string;
	raisonChangeDateDebut: string;

	constructor(
		isEnRapportAvecATMP: boolean = false,
		dateDebutATMP: string = '',
		dateDebut: string = formatDateStandard(dayjs()),
		dateFin: string = '',
		isRepriseTempsLeger: boolean = false,
		dateDebutRepriseTL: string = '',
		dateFinRepriseTL: string = '',
		dureeTL: string = '',
		duree: string = '',
		raisonChangeDateDebut: string = ''
	) {
		this.isEnRapportAvecATMP = isEnRapportAvecATMP;
		this.dateDebutATMP = dateDebutATMP;
		this.dateDebut = dateDebut;
		this.dateFin = dateFin;
		this.isRepriseTempsLeger = isRepriseTempsLeger;
		this.dateDebutRepriseTL = dateDebutRepriseTL;
		this.dateFinRepriseTL = dateFinRepriseTL;
		this.dureeTL = dureeTL;
		this.duree = duree;
		this.raisonChangeDateDebut = raisonChangeDateDebut;
	}
}
